// Styles
import styles from './ToGoPill.module.css';

/**
 * @function ToGoPill
 * Describes the number of cards that have the provided value remaining to win
 *
 * @example
 * return (
 *   <ToGoPill name={1} count={0} />
 * )
 */
function ToGoPill({ name, count }: ToGoPillProps): JSX.Element {
    return (
        <div className={`${styles.pill} ${styles[`pill-${name}-to-go`]}`}>
            {name}TG {count}
        </div>
    );
}

/**
 * @interface ToGoPillProps
 * Describes the properties required for the ToGoPill component
 *
 * @property {number} number Number remaining to win
 * @property {number} count Number of cards that match value remaining to win
 */
export interface ToGoPillProps {
    name: number;
    count: number;
}

// Exports
export default ToGoPill;
